(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcutils.share.factory:Share
   *
   * @description
   *
   */
  angular
    .module('vcutils.vcshare')
    .factory('Share', Share);
  
  
  Share.$inject = ['restmod'];
  function Share(restmod) {
    return restmod.model('/routes/shares').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/shares/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
